export function getPostcssMjs() {
  return `export default {
  plugins: {
    "@tailwindcss/postcss": {},
  },
};`;
}
